import React from "react";
import useViewDataObjectControl from "../../../hooks/portal/view/useViewDataObjectControl";
import { BoxSpg, CardSpg, isEmpty, WithChildren } from "@duosoftbg/nacid-components";
import { Alert, CardContent, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

const Loading = () => {
  return (
    <BoxSpg my={2} sx={{ display: "flex", boxShadow: 3 }} style={{ justifyContent: "center" }}>
      <CircularProgress size={20} />
    </BoxSpg>
  );
};

type ViewPageWrapperProps = WithChildren & {
  viewType: string;
  serviceFn: any;
  object: any;
};

const ViewPageWrapper = ({ children, viewType, serviceFn, object }: ViewPageWrapperProps) => {
  const { t } = useTranslation();
  const { isLoading, notFound } = useViewDataObjectControl({ viewType, serviceFn });

  if (notFound) {
    return <Alert severity="error">{t("m.error.serverFetchingError")}</Alert>;
  }

  if (isEmpty(object) || isLoading) {
    return <Loading />;
  }

  return (
    <CardSpg my={4} style={{ overflow: "visible" }}>
      <CardContent style={{ padding: 24, position: "relative" }}>{object?.data && <>{children}</>}</CardContent>
    </CardSpg>
  );
};

export default ViewPageWrapper;
